import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { collection, doc, getDoc } from 'firebase/firestore';
import { firestore } from '@/utils/firebase';
import BASE_QUERY from '@/features/baseQuery';

// Creating an API service using RTK Query
export const announcementsApi = createApi({
	reducerPath: 'announcementsApi',
	tagTypes: ['ANNOUNCEMENTS',],
	baseQuery: fetchBaseQuery(BASE_QUERY),
	endpoints: (builder) => ({
		getAnnouncements: builder.query({
			providesTags: (result, error, arg) => [],
			query: () => ({
				url: process.env.REACT_APP_RETRIEVE_ANNOUNCEMENTS,
				method: 'POST',
			}),
			transformErrorResponse: (response) => {
				console.log('👾 ~ transform getAnnouncements error response', response);
				return response;
			},
			transformResponse: (response) => {
				console.log('👾 ~ transform getAnnouncements response', response);
				return response;
			},
		}),
	}),
});

// Exporting auto-generated hooks for the defined endpoints
export const { useGetAnnouncementsQuery } = announcementsApi;